export enum BUTTON_COLOR {
	PRIMARY = 'primary',
	LIGHT = 'light',
	DARK = 'dark',
	NEUTRAL = 'neutral',
	GHOST = 'ghost'
}

export enum BUTTON_SIZE {
	EXTRA_SMALL = 'extra_small',
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large'
}

export enum BUTTON_VARIANT {
	ROUND = 'round',
	ROUNDED = 'rounded'
}

export enum ICON_POSITION {
	START = 'start',
	END = 'end'
}
